Shopify.Cart = Shopify.Cart || {};

Shopify.Cart.GiftWrap = {};

Shopify.Cart.GiftWrap.set = function(selectedItem) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: selectedItem, properties: {'Gift Wrap': 'Yes'} },
    dataType: 'json',
    success: function() {  }
  });
}

Shopify.Cart.GiftWrap.remove = function(selectedItem) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: selectedItem, properties: {'Gift Wrap': 'No'} },
    dataType: 'json',
    success: function() {  }
  });
}




// When the gift-wrapping checkbox is checked or unchecked.
jQuery(function() {

  // Adding Fancybox attribute to description size chart
    if(jQuery('.tabs_content_description').length > 0){
      jQuery('.tabs_content_description').find('a').each(function(index, element){
          if(jQuery(element).attr('href').includes('SIZE_CHART')) {
            var chart = jQuery(element).attr('href');
            jQuery(element).attr('data-fancybox','');
            jQuery('[data-fancybox]').fancybox({
            	toolbar  : false,
            	smallBtn : true
            })
          }
      });
    }
  
  jQuery('[name="gift-wrap"]').change(function() {
    var selectedItem = jQuery(this).attr("data-keyId");
	console.log("Change");

    if (jQuery(this).is(':checked')) {
      Shopify.Cart.GiftWrap.set(selectedItem);
    }
    else {
      Shopify.Cart.GiftWrap.remove(selectedItem);
    }
  });
  
  jQuery('.collection-page-heading p').each(function() {
    var $p = jQuery(this),
        txt = $p.html();
    if (txt=='&nbsp;') {
      $p.remove();   
    }
  });
  
  
  jQuery('body').on("change", ".collection-filters__checkbox", function(){
    jQuery('html').addClass("loading-filters");
  })
  
  
//   if(Custom.auto_add == true) {
//     Shopify.addItem(Custom.gift_variant,1,function(data){
//       console.log('dataaa', data);
//     });
//   }
  
});





document.addEventListener('theme:cart::added', event => {
 // var Custom = Custom || {};
  if(Custom.auto_add == true && Custom.gift_variant != '') {
     setTimeout(function(){
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      if(Custom.gift_type == 'purchase_amount') {
        if(data.total_price > Custom.minium_amount) {
          var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
          if(find_gift_product.length < 1) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      } else if(Custom.gift_type == 'collection_list'){
        var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
        if(find_gift_product.length < 1) {
          console.log('DDD');
          if(jQuery('.popup-cart__footer').hasClass('hasGiftCollection')) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      } else if(Custom.gift_type == 'title_contains') {
        var toteProduct = data.items.filter(item => item.title.includes(Custom.title_contains));
        if(toteProduct.length != 0) {
          var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
          if(find_gift_product.length < 1) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      } else if(Custom.gift_type == 'product_types') {
        if(data.total_price > Custom.minium_amount) {
          var toteProduct = data.items.filter(item => Custom.product_types.includes(item.product_type));
          if(toteProduct.length != 0) {
            var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
            if(find_gift_product.length < 1) {
              Shopify.addItem(Custom.gift_variant,1,function(data){});
            }
          }
        }
      }
      // var toteProduct = data.items.filter(item => item.title.includes('Tote'));
      // // if(data.total_price > 50000) {
      // if(toteProduct.length != 0) {
      //   var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
      //   if(find_gift_product.length < 1) {
      //     Shopify.addItem(Custom.gift_variant,1,function(data){});
      //   }
      // }
    }));
       },1000)
  }
    

  /* END: your code */
  (function($){
    if(!$) return;
    /* START: if you need jQuery */

    /* END: if you need jQuery */
  })(jQueryTheme);
});

document.addEventListener('theme:cart::removed', event => {
  /* Use veriables: event.detail, event.detail.button, event.detail.product, event.detail.data, event.detail.data.id */
  /* START: your code */
//   log('Removed from cart!', event.detail);
  
  if(Custom.auto_add == true && Custom.gift_variant != '') {
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      if(Custom.gift_type == 'purchase_amount') {
        if(data.total_price > Custom.minium_amount) {
          var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
          if(find_gift_product.length < 1) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      } else if(Custom.gift_type == 'collection_list'){
        var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
        if(find_gift_product.length < 1) {
          if(jQuery('.popup-cart__footer').hasClass('hasGiftCollection')) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      } else if(Custom.gift_type == 'title_contains') {
        var toteProduct = data.items.filter(item => item.title.includes(Custom.title_contains));
        if(toteProduct.length != 0) {
          var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
          if(find_gift_product.length < 1) {
            Shopify.addItem(Custom.gift_variant,1,function(data){});
          }
        }
      }
      // var toteProduct = data.items.filter(item => item.title.includes('Tote'));
      // // if(data.total_price > 50000) {
      // if(toteProduct.length != 0) {
      //   var find_gift_product = data.items.filter(item => item.variant_id == Custom.gift_variant);
      //   if(find_gift_product.length < 1) {
      //     Shopify.addItem(Custom.gift_variant,1,function(data){});
      //   }
      // }
    }));
  }

  /* END: your code */
  (function($){
    if(!$) return;
    /* START: if you need jQuery */
	
    /* END: if you need jQuery */
  })(jQueryTheme);
});

if(location.href.includes('cart')){
  
} else {
  document.addEventListener('rebuy:cart.change', (event) => {
    if(minMaxify.checkLimits()) {
       $('.rebuy-cart__checkout-button').removeClass("disabled");
    } else {
        $('.rebuy-cart__checkout-button').addClass("disabled");
    }
  });
  document.addEventListener('rebuy:smartcart.ready', (event) => {
  if(minMaxify.checkLimits()) {
     $('.rebuy-cart__checkout-button').removeClass("disabled");
  } else {
      $('.rebuy-cart__checkout-button').addClass("disabled");
  }
  });
}



// // Klaviyo Cart Event
// var _learnq = _learnq || [];
// function addedToCart() {
//   fetch(`${window.location.origin}/cart.js`)
//   .then(res => res.clone().json().then(data => {
//     var cart = {
//       total_price: data.total_price/100,
//       $value: data.total_price/100,
//       total_discount: data.total_discount,
//       original_total_price: data.original_total_price/100,
//       items: data.items
//     }

//     cart = Object.assign(cart, cart.items[0]);
    
// //     if (item !== 'undefined') {
// //       cart = Object.assign(cart, item)
// //     }
//     _learnq.push(['track', 'Added to Cart', cart])
//   }))
// } 
// (function (ns, fetch) {
//   ns.fetch = function() {
//     const response = fetch.apply(this, arguments);
//     response.then(res => {
//       if (`${window.location.origin}/cart/add.js`
//           .includes(res.url)) {
//         addedToCart()
//       }
//     });
//     return response
//   }
// }(window, window.fetch))

// jQuery(document).ajaxComplete(function(event,request,settings){

//   console.log("FDFDFDF",settings.url);
//   if(settings.url == "/cart/add.js"){
//     addedToCart();
//     console.log("Fired Add to Cart event");
//   }
// })




     // document.addEventListener("DOMContentLoaded", function() {
     //        const body = document.querySelector('body');
     //        const element = document.querySelector('#extra-col_banner:nth-child(1)');
     //        if (body && element) {
     //            body.classList.add('hide-body');
     //        }
     //    });